module.exports = __webpack_public_path__ + "img/criar_grupo.0a43e3a0.gif";